import lazyLoading from "./lazyLoading";

export default {
  name: "ustanove",
  path: "/ustanove",
  component: lazyLoading("ustanove/Ustanove"),
  meta: {
    default: false,
    title: "Ustanove",
    class: "primary",
    show: false,
    iconClass: "fa fa-h-square",
    requiredAuth: true
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/menu/ustanove.js